import React from "react";
import PropTypes from "prop-types";
import styled from "@emotion/styled";
import serviceImage from "../../assets/images/others/Service/Head massage 1.svg";
import { useSearchParams } from "react-router-dom";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  border-radius: 8px;
  overflow: auto;
  box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.25);
`;

const DetailsSection = styled.div`
  display: flex;
  flex-direction: column;
  background-color: #fff;
  height: 80px;
`;

const ViewAction = styled.div`
  background-color: #144fc3;
  color: #fff;
  font-family: Roboto;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  height: 40px;
  width: 100%;
`;

const SingleService = (props) => {
  const { data } = props;
  const [searchParams, setSearchParams] = useSearchParams();
  console.log("Service data: ", data);

  const clickHandler = () => {
    setSearchParams({
      dialog: "open",
      for: "services",
      action: "edit",
      id: data._id,
    });
  };

  return (
    <Container onClick={() => clickHandler(data)}>
      <img src={serviceImage} />
      <DetailsSection>{data.name}</DetailsSection>
      <DetailsSection>{data.description}</DetailsSection>
      <DetailsSection>{data.cost}</DetailsSection>
      <DetailsSection>{data.currency}</DetailsSection>
      <ViewAction>View Service</ViewAction>
    </Container>
  );
};

SingleService.propTypes = {};

export { SingleService };
